import type { DeviceType } from '@/app_lib/types/Gtm';

export const getDeviceForTracking = (): DeviceType | undefined => {
  if (typeof window === 'undefined' || !navigator?.userAgent) {
    return;
  }
  const ua = navigator.userAgent;
  if (/Mobi|Android/i.test(ua)) {
    return 'mobile';
  }
  if (/Tablet|iPad/i.test(ua)) {
    return 'tablet';
  }
  return 'desktop';
};
